import { Component, Input } from "@angular/core";
import { IEpisode } from "@project/models/episodes/episode";
import { OverlayPanel } from "primeng/overlaypanel";

@Component({
    selector: "merged-episode-overlay",
    template: `
        <ng-container *miproLoading="loadingEpisodeInfo; diameterPx: '17px'"></ng-container>
        <button
            [hidden]="loadingEpisodeInfo"
            doNotPropagateClick
            pRipple
            pButton
            type="button"
            label="m"
            class="p-button-secondary p-button-rounded p-button-text merge-icon"
            (click)="getEpisode(mergedInfo, $event)"></button>

        <p-overlayPanel #mergedInfo appendTo="body">
            <h5>Merged from:</h5>
            <episode-header-v2 *ngIf="episode" [episode]="episode" [showEllipsisButton]="false"></episode-header-v2>
        </p-overlayPanel>
    `
})
export class MergedEpisodeOverlayComponent {
    loadingEpisodeInfo: boolean = null;
    episode: IEpisode;

    @Input() loadEpisode: () => Promise<IEpisode>;

    async getEpisode(op: OverlayPanel, ev: Event) {
        if (typeof this.loadingEpisodeInfo === "boolean" || typeof this.loadEpisode !== "function") {
            op.toggle(ev);
            return;
        }

        try {
            this.loadingEpisodeInfo = true;
            this.episode = await this.loadEpisode();
        } finally {
            this.loadingEpisodeInfo = false;
            op.toggle(ev);
        }
    }
}
